export const th = {
  ADD_COLOR_STRING_KEY: 'เพิ่มสี',
  ADD_TEXT_KEY: 'เพิ่มข้อความ',
  ADD_TO_ORDER_KEY: 'สั่งเพิ่ม',
  ADD_TO_CART: 'เพิ่มไปยังรถเข็น',
  ADD_TEMPLATE: 'เพิ่มเทมเพลต',
  ADJUST_SIZE_KEY: 'ปรับแต่งขนาด',
  ADJUST_TRANSPARENCY_KEY: 'ปรับความโปร่งใส',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    'การคลิกเสร็จสิ้นเท่ากับคุณยอมรับข้อตกลงในการใช้งานและคำชี้แจงสิทธิส่วนบุคคลของ HP แล้ว',
  ALIGN_BOTTOM_KEY: 'จัดเรียงด้านล่าง',
  ALIGN_CENTER_KEY: 'จัดกึ่งกลาง',
  ALIGN_KEY: 'เป็นเส้นตรง',
  ALIGN_LEFT_KEY: 'เริ่มต้น',
  ALIGN_MIDDLE_KEY: 'จัดกึ่งกลาง',
  ALIGN_RIGHT_KEY: 'สิ้นสุด',
  ALIGN_TOP_KEY: 'จัดเรียงด้านบน',
  ALL_TAB_TITLE_KEY: 'ทั้งหมด',
  ALMOST_DONE_TITLE_KEY: 'เกือบเสร็จแล้ว!',
  AND_KEY: 'และ',
  APPLY_KEY: 'ใช้',
  AREA_CODE: 'รหัสพื้นที่',

  BASIC_HELPER_INSTRUCTION1_KEY:
    'เรียกดูเนื้อหาและเลือกรูปภาพสำหรับการออกแบบของคุณ หรืออัปโหลดเนื้อหาของคุณเอง',
  BASIC_HELPER_INSTRUCTION2_KEY:
    'แสดงตัวอย่างการออกแบบของคุณ หรือปรับแต่งรายละเอียด',
  BASIC_HELPER_INSTRUCTION3_KEY:
    'ปรับแต่งการออกแบบและเพิ่มองค์ประกอบอื่นๆ ไปยังโปรเจคของคุณ',
  BASIC_HELPER_INSTRUCTION4_KEY:
    'เมื่อการออกแบบพร้อมแล้ว ให้คลิกถัดไปเพื่อทำการตรวจสอบครั้งสุดท้ายและส่งคำสั่ง',
  BACK_KEY: 'ย้อนกลับ',
  BACKGROUND_KEY: 'พื้นหลัง',
  BACKGROUND_UPPER_CASE_KEY: 'พื้นหลัง',
  BACKGROUND_CONTRAST_KEY: 'ความคมชัดของพื้นหลัง',
  BLANK_INSPIRATION_CATEGORY_KEY: 'ไม่พบแรงบันดาลใจในหมวดหมู่นี้',
  BRING_TO_FRONT_KEY: 'นำมาไว้ด้านหน้า',
  CANCEL_TEXT_KEY: ' ยกเลิก ',
  CENTIMETERS_KEY: 'เซนติเมตร',
  CM_KEY: 'ซม.',
  CHANGE_YOUR_SETTINGS_KEY: 'เปลี่ยนการตั้งค่าโครงการของคุณ',
  CHECKBOX_CONTENT1: 'ฉันต้องการรับจดหมายข่าวการออกแบบลวดลาย',
  CHECKBOX_CONTENT2:
    'ฉันอนุญาตให้ HP สร้างบัญชีในบริการออกแบบลวดลาย©ในนามของฉัน',
  CHOOSE_FROM_COMPUTER_KEY: 'เลือกจากคอมพิวเตอร์',
  CHOOSE_RIP_OPTIONS: 'เลือกหนึ่งใน RIP ที่เข้ากันได้ของบริษัทอื่น',
  CHOOSE_FILE_KEY: 'เลือกไฟล์',
  CITY: 'เมือง',
  CLEAR_ALL_KEY: 'ล้างทั้งหมด',
  CLEAR_COLOR_KEY: 'ล้างสี',
  CLOSE_WINDOW_KEY: 'ปิดหน้าต่าง',
  CLEAR_ALL_OBJECTS: 'ล้างวัตถุทั้งหมด',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE:
    'นี่จะเป็นการลบวัตถุทั้งหมดออกจากพื้นหลังของคุณ',
  CLEAR_DESIGN_KEY: 'ล้างการออกแบบ',
  COLOR_KEY: 'สี',
  CONTINUE_KEY: 'ดำเนินการต่อ...',
  COMPANY: 'บริษัท',
  CONGRATULATIONS_KEY: 'ขอแสดงความยินดี!',
  CONFIRM_PASSWORD: 'ยืนยันรหัสผ่าน',
  CONFIRM_PATTERN_ACCOUNT_KEY: 'ยังไม่มีบัญชี Pattern Design ใช่หรือไม่',
  CONFIRM_VECTEEZY_ACCOUNT_KEY: 'ยังไม่มีบัญชี Vecteezy?',
  COUNTRY: 'ประเทศ',
  CREATE_ACCOUNT: 'สร้างบัญชี',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P',
  CUSTOM_KEY: 'กำหนดเอง',
  CUSTOM_PRICE_SIGN_IN_KEY: 'เข้าสู่ระบบในขั้นตอนต่อไปเพื่อดูราคาแบบกำหนดเอง',
  CM_UNIT_KEY: 'ซม.',
  CREATE_NEW: 'สร้างใหม่',
  DESIGN_KEY: 'ออกแบบ',
  DELETE_KEY: 'ลบ',
  DOCUMENT_COLORS: 'สีเอกสาร',
  DONE: 'เสร็จสิ้น!',
  DONE_KEY: 'เสร็จสิ้น',
  DONT_SHOW_ALERT_KEY: 'ไม่ต้องแสดงอีก',
  DOWNLOAD_COLUMN_HEADER_KEY: 'ดาวน์โหลด',
  DOWNLOAD_APP_TITLE_KEY: 'คุณสามารถดาวน์โหลดแอปได้ที่นี่:',
  DOWNLOAD_LINK_KEY: 'ดาวน์โหลด HP Click ฟรีได้ที่นี่',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'ดาวน์โหลด HP SmartStream',
  DOWNLOAD_INSTR_KEY:
    'ตรวจสอบให้แน่ใจว่าได้ติดตั้ง HP Click แล้วก่อนดำเนินการต่อ',
  DOWNLOAD_SMARTSTREAM_KEY: 'ดาวน์โหลด HP SmartStream',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'นำเข้า Dropbox',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    'ขนาดของรูปภาพไม่ควรเกิน 1 GB เรารับรูปแบบไฟล์ pdf, png, jpg, svg และ tiff',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'ค้นหาในฝัน',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'ภาพในฝัน',
  DUPLICATE_KEY: 'ทำสำเนา',
  EACH_ITEM_PRICE_KEY:
    'การออกแบบของคุณประกอบด้วยเนื้อหาจากหนึ่งในผู้ให้บริการเนื้อหาพรีเมียม การกำหนดราคาแบบแยกรายการขององค์ประกอบสรุปไว้ด้านล่าง',
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'แก้ไขดีไซน์',
  EDIT_LOWERCASE_KEY: 'แก้ไข',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT:
    'เราขออภัย มีข้อผิดพลาดเกิดขึ้น โปรดลองอีกครั้งในภายหลัง',
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    'อุ๊บส์ มีข้อผิดพลาดในการเปิดไฟล์ PDF ที่อัพโหลด',
  EMAIL_KEY: 'อีเมล',
  EMAIL_ADDRESS_KEY: 'ที่อยู่อีเมล:',
  EMAIL_CHECKBOX_MESSAGE:
    'ฉันทราบว่าบุคคลนี้เข้าใจว่าจะได้รับอีเมลจาก HP ในนามของฉันหรือผู้ให้บริการรายนี้',
  EXTRA_INFO_KEY: 'ข้อมูลเพิ่มเติม',
  EMAIL_NOTIFICATION:
    'อีเมลจะส่งไปเร็วๆ นี้ โปรดรอประมาณ  15 นาทีสำหรับการประมวลผล',
  EMAIL_DIALOG_MESSAGE:
    'พิมพ์ที่อยู่อีเมลของบุคคลที่คุณต้องการแชร์การออกแบบด้วย',
  ENTER_KEY: 'ป้อน',
  EXISTING_FOLDER_KEY: 'โฟลเดอร์ที่มีอยู่',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    'ตรวจสอบให้แน่ใจว่า รายการสินค้าที่เลือกไว้ถูกต้อง ก่อนที่คุณจะชำระเงิน',
  FINAL_CHECK_TITLE_KEY: 'การตรวจสอบขั้นสุดท้าย',
  FINISH_KEY: 'เสร็จสิ้น',
  FINISH_LATER_KEY: 'เสร็จสิ้นในภายหลัง',
  FIRSTNAME: 'ชื่อจริง',
  FISCAL_NUM: 'หมายเลขการคลัง',
  FLIP_KEY: 'พลิก',
  FOR_KEY: 'สำหรับ',
  FORGOT_PASSWORD_KEY: 'ลืมรหัสผ่านใช่ไหม',
  FOTOLIA_KEYWORDS_KEY: 'คำสำคัญ:',
  FOLDER_NAME: 'ชื่อโฟลเดอร์',
  FOLDER_NAME_KEY: 'ชื่อโฟลเดอร์:',
  FOLDER_ALREADY_EXIST_KEY: 'ชื่อโฟลเดอร์นี้มีอยู่แล้ว',
  FREE_POSTER_COMPLETE_MESSAGE_KEY: 'คุณออกแบบโปสเตอร์ฟรีเสร็จสมบูรณ์แล้ว',
  FREE_VECTOR_GRAPHICS_KEY: 'กราฟิกแบบเวกเตอร์ฟรี',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: 'โอเค ฉันเข้าใจแล้ว',
  GROUP_ALL_KEY: 'จัดกลุ่มทั้งหมด',
  GROUP_SCALE: 'ขนาดกลุ่ม',
  GIFT_WRAPS_KEY: 'ห่อของขวัญ',
  GIVE_PROJECT_NAME_KEY: 'ตั้งชื่อโปรเจคของคุณ',
  HEIGHT_KEY: 'ความสูง',
  TOUR_DESCRIPTION_TEXT:
    'ให้เราแนะนำคุณตลอดกระบวนการออกแบบ อย่าลืมว่าคุณสามารถเปิดการแนะนำใหม่เมื่อใดก็ตามที่คุณต้องการด้วยการคลิกที่ไอคอนช่วยเหลือ',
  HELP_KEY: 'วิธีใช้',
  HELPER_TITLE_KEY_1:
    'สร้างการออกแบบโปสเตอร์จากหน้าว่างหรือจากรูปภาพและข้อความนับล้าน อัปโหลดเนื้อหาของคุณเองจากไดรฟ์ในท้องถิ่น Dropbox หรือโซเชียลมีเดีย',
  HELPER_TITLE_KEY_3: 'ดูงานออกแบบทั้งหมดของคุณได้ในที่เดียว',
  HELPER_TITLE_KEY_4:
    'คลิกถัดไปเพื่อดูตัวอย่างและเสร็จสิ้นการออกแบบขั้นสุดท้าย',
  HERE_KEY: 'ที่นี่',
  HELP_IMPROVE_KEY:
    'ช่วยพัฒนาประสิทธิภาพการผลิตและประสิทธิภาพการทำงานของคุณ และขยายขึ้นด้วยการผลิตสี',
  HIGH_QUALITY_KEY: 'คุณภาพสูง',
  IMAGES_TITLE_KEY: 'รูปภาพ',
  IMPERIAL_KEY: 'ของจักรพรรดิ',
  IMPORTING_KEY: 'กำลังนำเข้า',
  INCHES_COLUMN_HEADER_KEY: 'นิ้ว',
  INCHES_KEY: ' นิ้ว',
  INCHES_UNIT_STRING_KEY: 'นิ้ว',
  INVALID_EMAIL_ADDRESS_KEY: 'ที่อยู่อีเมลไม่ถูกต้อง',
  INVALID_INFO_KEY: 'โปรดป้อนรายละเอียด',
  INVALID_NAME_KEY: 'ชื่อไม่ถูกต้อง',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    'ขออภัย ไฟล์ที่คุณเลือกใหญ่เกินไป ขนาดไฟล์ที่ใหญ่ที่สุดคือ 500mb',
  INSUFFICIENT_CREDITS_KEY: 'เครดิตไม่เพียงพอ',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'แรงบันดาลใจ',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    'อุ๊บส์ นั่นไม่ใช่รูปแบบไฟล์ที่ถูกต้อง เราดำเนินการได้เฉพาะ pdf, jpg, png, svg และ tif เท่านั้น',
  LANDSCAPE_KEY: 'แนวนอน',
  LANGUAGE_LABLE_KEY: 'ภาษา',
  LASTNAME: 'นามสกุล',
  LEARN_MORE: 'เรียนรู้เพิ่มเติม',
  LEARN_THE_BASICS_KEY: 'เรียนรู้พื้นฐาน',
  LEGAL_FOOTER_MESSAGE1_KEY:
    'การใช้งานเว็บไซต์นี้เท่ากับคุณได้ยอมรับที่จะผูกมัดกับข้อกำหนดนี้แล้ว',
  LEGAL_FOOTER_MESSAGE2_KEY: 'เว็บไซต์นี้เป็นไปตาม',
  LEGAL_FOOTER_MESSAGE3_KEY: 'และ',
  LENGTH_STRING_IN_INCHES_KEY: 'นิ้ว',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: 'เปลี่ยน',
  LINK_READER_APP_KEY: 'แอป LinkReader',
  LINK_READER_APP_DESCRIPTION_KEY:
    'หากต้องการจำลองเนื้อหาที่คุณเพิ่มเข้า โปรดดาวน์โหลดแอป LinkReader',
  LOADING_KEY: 'กำลังโหลด...',
  LOADING_TEMPLATE_KEY: 'กำลังโหลดเทมเพลต',
  LOGIN_NOW: 'ลงชื่อเข้าใช้ตอนนี้',
  LOCK_KEY: 'ล็อค',
  LOGIN_KEY: 'เข้าสู่ระบบ',
  LOGIN_PATTERN_DESIGN_KEY: 'เข้าสู่ระบบ Pattern design',
  LOGIN_SUBTITLE_KEY:
    'เข้าสู่ระบบเพื่อดูราคาแบบกำหนดเองและรายละเอียดการชำระเงิน',
  LOGIN_VECTEEZY_KEY: 'เข้าสู่ระบบ Vecteezy',
  LOGIN_DREAMSTIME_KEY: 'เข้าสู่ระบบ Dreamstime ',
  LOGOUT_KEY: 'ออกจากระบบ',
  MATERIAL_TITLE_KEY: 'วัสดุ',
  MATERIAL_STRING_KEY: 'วัสดุ',
  MEASUREMENT_KEY: 'การวัดขนาด',
  METRIC_KEY: 'เมตริก',
  MOBILE: 'โทรศัพท์มือถือ',
  MODEL_TITLE_KEY: 'โมเดล',
  MORE_INFO_TEXT_KEY: 'ข้อมูลเพิ่มเติม',
  MY_GIFTWRAPS_KEY: 'ห่อของขวัญของฉัน',
  MY_WORK_KEY: 'งานของฉัน',
  MY_WORK_SAVE_KEY:
    'การออกแบบของคุณได้รับการบันทึกลงใน My Work space ของคุณแล้ว',
  NAME_KEY: 'ชื่อ:',
  NEXT_BUTTON_TITLE_KEY: 'ถัดไป',
  NEW_FOLDER_KEY: 'โฟลเดอร์ใหม่',
  NO_SHADOW_KEY: 'ไม่มีเงา',
  OBJECT_QUANTITY_KEY: 'ปริมาณ',
  OBJECTS_UPPER_CASE_KEY: 'วัตถุ',
  OK_KEY: 'ตกลง',
  ORDER_SAMPLE_KEY: 'สั่งตัวอย่าง',
  ORDER_SAMPLE: 'สั่งตัวอย่าง',
  ORDER_SAMPLE_INFOLABEL_1: 'เลือกส่วนของรูปภาพที่คุณต้องการสั่งเป็นตัวอย่าง',
  ORDER_SAMPLE_INFOLABEL_2:
    'คุณจะได้รับอีเมลที่มีมุมมองโคลสอัพของโปรเจคของคุณในขนาดจริง',
  ORDER_SAMPLE_INFOLABEL_3:
    'ซึ่งจะช่วยให้คุณสามารถประเมินคุณภาพและความละเอียดของโปรเจคได้',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: 'สั่งตัวอย่างตอนนี้',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    'รับอีเมลที่ประกอบด้วยมุมมองโคลสอัพของโปรเจคของคุณตามขนาดจริงเพื่อประเมินคุณภาพ/ความละเอียด',
  ORIENTATION_KEY: 'การวางแนวกระดาษ',
  OTHER_PRINTING_OPTIONS: 'ตัวเลือกการพิมพ์อื่นๆ',
  PASSWORD_KEY: 'รหัสผ่าน',
  PATTERN_COLOR_KEY: 'สีรูปแบบ',
  PATTERN_DESIGN_TITLE_KEY: 'Pattern Design',
  PATTERNS_FOR_KEY: 'รูปแบบสำหรับ',
  PDF_GENERATION_ERROR_MESSAGE_KEY: 'การสร้าง pdf ล้มเหลว โปรดลองอีกครั้ง',
  PHOTOS_KEY: 'ภาพถ่าย',
  PHOTO: 'ภาพถ่าย',
  PHONE: 'โทรศัพท์',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    'ฉันเป็นเจ้าของลิขสิทธิ์ภาพนี้และตกลงที่จะ',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    'ขนาดของรูปภาพไม่ควรเกิน 500 MB เรารับรูปแบบไฟล์ png, jpg, tiff, svg และ pdf',
  PIXEL_COLUMN_HEADER_KEY: 'พิกเซล',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'ซม.',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'ป้อนข้อความที่นี่ ...',
  PLACEHOLDER_EXTRA_INFO_KEY:
    'เช่น ข้อมูลสำคัญบางประการที่คุณต้องการแจ้งแก่ร้านพิมพ์',
  PLACEHOLDER_INCHES_STRING_KEY: 'นิ้ว',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'โปสเตอร์ของฉัน',
  PORTRAIT_KEY: 'แนวตั้ง',
  POSITION: 'ตำแหน่ง',
  PREMIUM_IMAGES_TITLE_KEY: 'รูปภาพพรีเมียม:',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'บันทึกโปรเจคของคุณ',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    'โปรเจคของคุณมีการเปลี่ยนแปลงที่จำเป็นต้องบันทึกก่อนดำเนินการต่อ',
  PRICE_COLUMN_HEADER_KEY: 'ราคา',
  PRINTER_SERIAL_NUMBER_KEY: 'หมายเลขซีเรียลของเครื่องพิมพ์*',
  PRINTING_ENABLE_DETAILS_KEY:
    'เพื่อให้สามารถพิมพ์ได้เราต้องการรายละเอียดอีกเล็กน้อย',
  PRINTER_MODELS_KEY: 'รุ่นของเครื่องพิมพ์*',
  PROCESSING_KEY: 'กำลังประมวลผล...',
  PROCESSING_ALERT_TXT:
    'อย่าปิดหน้าต่างนี้ในขณะที่เรากำลังประมวลผลการออกแบบของคุณ',
  PROCESSING_ALERT_TXT2:
    'เมื่อการประมวลเสร็จสมบูรณ์ HP Click จะเปิดโดยอัตโนมัติและเริ่มดาวน์โหลดไฟล์ของคุณ',
  PROCESSING_DONE: 'คุณเกือบเสร็จสิ้นแล้ว!',
  PROCESSING_FILE_TXT: 'ไฟล์ของคุณกำลังประมวลผล',
  PROCESSING_TIME_TXT:
    'อาจใช้เวลาสักครู่ในขณะที่เราเรียบเรียงผลงานสร้างสรรค์ของคุณเพื่อให้แน่ใจว่ารูปภาพมีคุณภาพดีที่สุด',
  PROCESSING_ALERT_TXT3: 'PDF ของคุณจะดาวน์โหลดไปยังคอมพิวเตอร์โดยอัตโนมัติ',
  PROCESSING_ALERT_TXT4:
    'อย่าลืมว่าคุณสามารถกำหนดค่าการเชื่อมต่อ JDF สำหรับระบบอัตโนมัติได้ในการตั้งค่า',
  PREMIUM_CONTENT_KEY: 'เนื้อหาพรีเมียม',
  PREVIEW_KEY: 'แสดงตัวอย่าง',
  PROFESSIONAL_USE_TITLE_KEY: 'การใช้งานระดับมืออาชีพ',
  PROJECT_NAME_KEY: 'ชื่อโปรเจค',
  PROJECT_NAME: 'ชื่อโปรเจค:',
  PROJECT_ALREADY_EXIST_KEY: 'ชื่อโปรเจคนี้มีอยู่แล้ว',
  NONUNIQUE_PROJECT_NAME_MESSAGE: 'ชื่อโปรเจคนี้มีอยู่แล้ว',
  NONUNIQUE_FOLDER_NAME_MESSAGE: 'ชื่อโฟลเดอร์นี้มีอยู่แล้ว',
  PIXELATION_WARNING_KEY: 'คำเตือนการปรากฏเป็นพิกเซล',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    'เนื่องจากความละเอียดของรูปภาพที่คุณอัปโหลด ผิวหนังของคุณอาจบิดเบี้ยวหรือบิดเบี้ยว เพื่อให้แน่ใจว่าไม่มีภาพเบลอ โปรดอัปโหลดภาพที่มีคุณภาพดีและหลีกเลี่ยงการยืดภาพ หากคุณพอใจกับการแสดงตัวอย่างและต้องการดำเนินการต่อ โปรดส่งต่อไป',
  REGISTER_CONTACTINFO: 'ข้อมูลติดต่อ',
  REGISTER_INFO: 'ลงทะเบียนข้อมูล',
  REGISTER_PATTERNSUB1: 'ในฐานะลูกค้า HP ที่มีคุณค่า,',
  REQUIRED_FIELDS_KEY: 'ฟิลด์ที่ต้องระบุ',
  REQUIRED_FIELDS_TEXT_KEY: 'ฟิลด์ที่ต้องระบุ',
  REQUIRED_STRING_KEY: 'จำเป็นต้องใช้',
  RECOLOR_KEY: 'การเปลี่ยนสี',
  RADICALLY_SIMPLE_KEY: 'ซอฟต์แวร์ด้านการพิมพ์ที่ใช้งานง่ายถึงขีดสุด',
  RIPSELECTION_HEAD:
    'นี่คือครั้งแรกของคุณ เลือกซอฟต์แวร์การพิมพ์ที่เข้ากันได้ที่คุณต้องการ',
  RIPSELECTION_DESC:
    'การเลือกของคุณจะกลายเป็นตัวเลือกการพิมพ์เริ่มต้นสำหรับการพิมพ์ครั้งต่อไปในอนาคต การเปลี่ยนแปลงสามารถทำได้ในภายหลังที่การตั้งค่า',
  REGISTER_COMPANYINFO: 'ข้อมูล บริษัท',
  REGISTER_KEY: 'ลงทะเบียน',
  REGISTER_NOW: 'ลงทะเบียนตอนนี้',
  REOLOR_KEY: 'การเปลี่ยนสี',
  REQUEST_SAMPLE_KEY: 'ขอตัวอย่าง',
  RESIZE_KEY: 'ปรับขนาด',
  RESIZE_ARBITRARILY_KEY: 'ปรับขนาดตามใจชอบ',
  RESIZE_PROPORTIONALLY_KEY: 'ปรับขนาดตามส่วน',
  REVIEW_AND_SUBMIT_KEY: 'ตรวจสอบและส่ง',
  REQUEST_FOR_QUOTATION: 'คำขอสำหรับการเสนอราคา',
  RIGHT_LOGO_TEXT_KEY: 'โดย',
  ROTATE_KEY: 'หมุน',
  ROTATE_LEFT_KEY: 'หมุนไปทางซ้าย 90°',
  ROTATE_RIGHT_KEY: 'หมุนไปทางขวา 90°',
  ROTATION_KEY: 'การหมุน',
  ROWS_COLUMN_LABEL_STRING_KEY: 'แถวและคอลัมน์',
  ROYALTY_FREE_KEY: 'ไม่มีค่าลิขสิทธิ์',
  ROYALTY_KEY: 'พระบรมวงศานุวงศ์',
  SALUTATION: 'คำอวยพร',
  SAVE_KEY: 'บันทึก',
  SAVING_KEY: 'กำลังบันทึก...',
  SAVE_INSPIRATION: 'บันทึกแรงบันดาลใจ',
  SAVE_TEMPLATE: 'บันทึกเทมเพลต',
  SAVE_DIALOG_TITLE: 'บันทึกโปรเจคของคุณ',
  SAVE_PROJECT_NAME_KEY: 'บันทึกโปรเจคของคุณก่อน',
  SAVEDIALOG_MESSAGE:
    'โปรดเข้าสู่ระบบเพื่อบันทึกโปรเจคของคุณ หากคุณไม่มีบัญชี เราจะช่วยสร้างบัญชีให้คุณ การดำเนินการของคุณจะไม่สูญหาย',
  SEAMLESS_KEY: 'ไร้รอยต่อ',
  SCALE_INFO_STRING_KEY: 'ปรับขนาดรูปภาพเพื่อให้พอดีกับการออกแบบของคุณ',
  SCALE_KEY: 'ปรับขนาด',
  SCALE_ALL_KEY: 'ปรับขนาดทั้งหมด',
  SCALE_TO_FILL_KEY: 'ขนาดที่จะเติม',
  SEARCH_BUTTON_TITLE_KEY: 'ค้นหา',
  SELECT_CUSTOM_SIZE_KEY: 'เลือกขนาดที่กำหนดเอง',
  SELECT_CUSTOM_KEY: 'กำหนดเอง',
  SEARCH_TITLE: 'ค้นหา',
  SELECTED_IMAGE_KEY: 'รูปภาพที่เลือก:',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'เลือกขนาดห่อของขวัญ',
  SELECT_COUNTRY: 'เลือกประเทศ',
  SELECT_SALUTATION: '---เลือก---',
  SELECT_POSTER_SIZE_KEY: 'เลือกขนาดโปสเตอร์',
  SELECT_PRINTING_OPTION_KEY: 'เลือกตัวเลือกการพิมพ์ที่คุณต้องการ',
  SEND_INSTALLATION_INSTRUCTION_KEY: 'ส่งคำแนะนำการติดตั้งให้ฉัน',
  SEND_TO_BACK_KEY: 'ส่งไปด้านหลัง',
  SEND_KEY: 'ส่ง',
  SEND_TO_PRINT_TITLE_KEY: 'ส่งเพื่อพิมพ์',
  SET_SIZE_KEY: 'ตั้งค่าขนาด',
  SETTINGS_KEY: 'การตั้งค่า',
  SETTINGS_UPPERCASE_KEY: 'การตั้งค่า',
  SHARE_KEY: 'แชร์',
  SIGNED_IN_AS_KEY: 'ลงชื่อเข้าใช้เป็น',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'ลงชื่อเข้าใช้หรือลงทะเบียนเพื่อดูการกำหนดราคาแบบกำหนดเองและรายละเอียดการชำระเงิน',
  SIGN_UP_NOW_KEY: 'สมัครเลย',
  SKIP_KEY: 'ข้าม',
  SOLID_COLORS_KEY: 'สีทึบ',
  SQFT_UNIT_STRING_KEY: 'ตารางฟุต',
  SQM_UNIT_STRING_KEY: 'ตร.ม.',
  START_TOUR_KEY: 'เริ่มการแนะนำ',
  STATUS_MSG: 'ไฟล์ของคุณถูกส่งไปพิมพ์แล้ว!',
  SUBMIT_BUTTON_KEY: 'เสนอ',
  SHARE_LINK_LABEL: 'เลือกประเภทของลิงก์ที่คุณต้องการแชร์',
  SHARE_EDIT_LINK: 'แก้ไขลิงก์',
  SHARE_VIEW_LINK: 'ดูลิงก์',
  SHARE_YOUR_CREATION: 'แชร์ผลงานสร้างสรรค์ของคุณ',
  STREET_ADD: 'ที่อยู่ถนน',
  TARGET_VIEWING_HINT:
    '* ระยะการมองเห็นเป้าหมายสามารถเปลี่ยนแปลงได้จากการตั้งค่า',
  TERMS1_KEY: 'ข้อกำหนด',
  TERMS2_KEY: 'คำชี้แจงสิทธิส่วนบุคคลของ HP',
  TERMS3_KEY: 'ประกาศเกี่ยวกับสิทธิ์ในข้อมูลส่วนบุคคลของ HP',
  TERMS_OF_USE_KEY: 'ข้อตกลงการใช้งาน',
  TERMS_OF_USE: 'ข้อกำหนดการใช้งาน',
  TEXT_SHADOW_COLOR_KEY: 'สีเงาของข้อความ',
  TEXT_ANCHOR_MIDDLE: 'กลาง',
  TEXT_UPPERCASE_KEY: 'ข้อความ',
  TILE_KEY: 'ไทล์',
  TOTAL_KEY: 'ทั้งหมด',
  TOTAL_PRICE_KEY: 'ยอดรวม:',
  TRANSPARENCY_KEY: 'ความโปร่งใส',
  TEMPLATES_KEY: 'แม่แบบ',
  TEMPLATES_UPPER_CASE_KEY: 'แม่แบบ',
  THANK_YOU_KEY: 'ขอบคุณ',
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: 'ปลดล็อค',
  UNGROUP_KEY: 'ยกเลิกการจัดกลุ่ม',
  UPDATE_TEXT_KEY: 'อัปเดต',
  UPLOAD_KEY: 'อัปโหลด',
  UPLOAD_LOGO_KEY: 'อัพโหลดโลโก้',
  UPLOAD_IMAGE_KEY: 'อัปโหลดรูปภาพของคุณ',
  UPLOAD_UPPERCASE_KEY: 'อัพโหลด',
  USER_NAME: 'ชื่อผู้ใช้',
  USER_TYPE_TITLE_KEY: 'คุณเป็นผู้ใช้ประเภทใด*',
  UNTILE_KEY: 'นำไทล์ออก',
  UNSPLASH_SEARCH_TITLE: 'ค้นหา Unsplash',
  VALIDITY_KEY: 'ความถูกต้อง',
  VANILLA_LOGIN_DIALOG_KEY:
    'เข้าร่วมโดยไม่มีค่าใช้จ่ายเพื่อบันทึกและพิมพ์การออกแบบของคุณและดูงานที่บันทึกแล้วของคุณ',
  VANILLA_PREVIEW_MESSAGE_KEY:
    'นี่คือตัวอย่างการออกแบบของคุณ ตรวจสอบว่าการออกแบบนี้อยู่ในขั้นสุดท้ายก่อนดำเนินการต่อหรือเลือกแก้ไขเพื่อทำการเปลี่ยนแปลง',
  VAT_KEY: 'VAT',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'เวกเตอร์',
  VIEW_FOTOLIA_KEY: 'ดูใน Fotolia©',
  VIEW_GETTY_IMAGE_KEY: 'View in Getty Image©',
  VIEW_I_STOCK_KEY: 'View in iStock©',
  VIEW_DESIGN_DETAILS_KEY: 'ดูรายละเอียดการออกแบบ',
  VIEW_DESIGNER_PROFILE_KEY: 'ดูโปรไฟล์นักออกแบบ',
  VIEW_PRICE_KEY: 'ดูราคา',
  VECTEEZY_SEARCH_TITLE: 'ค้นหา Vecteezy',
  WALL_POSTER_KEY: 'โปสเตอร์',
  WALL_SIZE_TEXT_KEY: 'ขนาดผนัง',
  WARNING_KEY: 'คำเตือน',
  WEBSITE: 'เว็บไซต์',
  WIDTH_KEY: 'ความกว้าง',

  YOU_CAN_ALWAYS_ACCESS: 'คุณสามารถเข้าถึงการออกแบบของคุณได้ทุกเมื่อที่ ',
  YOUR_NAME_KEY: 'ชื่อของคุณ',
  YOUR_SELECTION_WILL_KEY:
    'การเลือกของคุณจะกลายเป็นเส้นทางการพิมพ์เริ่มต้นสำหรับการพิมพ์ครั้งต่อไปในอนาคต',
  YOUR_PROJECT_KEY: 'โปรเจคของคุณ:',
  PROJECT_NAME_ERROR_TEXT: 'โปรดป้อนชื่อสำหรับโปรเจคของคุณ',
  PROJECT_FOLDER_ERROR_TEXT: 'โปรดป้อนชื่อสำหรับโฟลเดอร์โปรเจคของคุณ',
  PIXELATION_WARNING_SETTINGS_KEY: 'การตั้งค่าคำเตือนการปรากฏเป็นพิกเซล',
  MINIMUM_VIEWING_DISTANCE_KEY: 'ระยะการมองเห็นขั้นต่ำ',
  BACKGROUND_UPLOAD_KEY: 'พื้นหลัง',
  OBJECT_UPLOAD_KEY: 'วัตถุ',
  PHOTO_UPLOAD_KEY: 'ภาพถ่าย',
  NO_DREAMSTIME_ERROR_MESSAGE: 'ไม่พบเนื้อหาในฝัน',
  NO_ELEMENT_ERROR_MESSAGE: 'ไม่พบองค์ประกอบ',
  NO_MORE_IMAGES_FOUND_KEY: 'ไม่พบรูปภาพอีก',
  NO_PATTERN_ERROR_MESSAGE: 'ไม่พบรูปแบบ',
  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',
  ALREDY_HAVE_AN_ACCOUNT: 'มีอยู่แล้ว {0} บัญชี?',
  CHANGE_MEASURING_SYSTEM_KEY: 'เปลี่ยนเป็น {0}',
  DOWNLOADS_KEY: '{0} ดาวน์โหลด',
  HEX_COLOR_KEY: 'สีฐานสิบหก: {0}',
  NEAR_KEY: 'ใกล้',
  FAR_KEY: 'ห่างไกล',
  CLOSE_UP_KEY: 'ใกล้ชิด',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    'รูปภาพที่คุณพยายามใช้มีขนาดเล็กกว่าหรือใหญ่กว่าพื้นที่การออกแบบที่คุณใช้',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    'เพื่อให้ได้ผลลัพธ์ที่ดีขึ้นให้ใช้ภาพความละเอียด 999 ภาพ',
  MESSAGE_KEY: 'ข้อความ:',
  VIEWS_KEY: '{0} มุมมอง',
  COST_DESCRIPTION_MESSAGE_KEY:
    'นี่คือสรุปราคาที่เกี่ยวข้องกับเนื้อหาพรีเมียมที่อยู่ในการออกแบบของคุณ {0} การเลือกสิ้นสุดเท่ากับคุณได้ยอมรับการเรียกเก็บเงินค่าใช้จ่ายต่อไปนี้โดยผู้ให้บริการเนื้อหา',
  DEFAULT_PRINTING_OPTION_KEY: '{0} เป็นตัวเลือกการพิมพ์เริ่มต้นของคุณ',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    ' คุณจะได้รับภาพความละเอียดสูงมูลค่า $ 100 {0} เพื่อช่วยตอบสนองความต้องการที่สร้างสรรค์ของคุณ!',
  REGISTER_PATTERNSUB3:
    'ลงทะเบียนวันนี้และในอีก 30 วันข้างหน้าดาวน์โหลดไฟล์สร้างสรรค์จากฐานเนื้อหาของเราจำนวน 25 ล้านภาพและดูวิธีการ {0} สามารถช่วยคุณตอบสนองความต้องการที่สร้างสรรค์ของคุณ',
  ZOOM_WARNING_PIXELATED_TEXT:
    'คุณได้ปรับขนาดจนถึงจุดที่รูปภาพที่พิมพ์ของคุณปรากฏเป็นพิกเซลเมื่อมองในระยะ {0} {1} * (ความละเอียดของการพิมพ์ปัจจุบันคือ {2}dpi)',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    'ระยะของการมองเห็นที่แนะนำควรเป็น {0} {1} หากไม่ใช่ระยะที่เหมาะสม โปรดลดขนาดของรูปภาพหรือขนาดของผนังของคุณ',
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    'ขนาดรูปภาพขั้นต่ำที่แนะนำควรจะเป็น {0} x {1} พิกเซล',
  UPLOAD_STATUS: '{0}% of {1}MB',
  REGISTER_TO: 'ลงทะเบียนเพื่อ {0}',

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  MINIMUM_DIMENSIONS_KEY: 'ขนาดต่ำสุดคือ {0} (กว้าง) คูณ {1} (สูง)',
  MINIMUM_HEIGHT_KEY: 'ความสูงต่ำสุดคือ {0}',
  MINIMUM_WIDTH_KEY: 'ความกว้างต่ำสุดคือ {0}',
  MAXIMUM_DIMENSIONS_KEY: 'ขนาดใหญ่ที่สุดคือ {0} (กว้าง) คูณ {1} (สูง)',
  MAXIMUM_WIDTH_KEY: 'ความกว้างสูงสุดคือ {0}',
  MAXIMUM_HEIGHT_KEY: 'ความสูงสูงสุดคือ {0}',
  INVALID_NUMBER_ERROR_TEXT_KEY: 'โปรดใส่ขนาดด้วยตัวเลขที่มากกว่าศูนย์',
  PROCESSING_FAILED: 'การประมวลผลล้มเหลว โปรดลองอีกครั้งในภายหลัง',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT: 'ขออภัย ไม่รองรับ PDF แบบหลายหน้า',
  MINIMUM_ZOOM_WARNING:
    'ไม่สามารถปรับขนาดพื้นหลังนี้ลงได้มากกว่านี้แล้วเนื่องจากคุณได้ปรับขนาดจนถึงความสูงหรือความกว้างขั้นต่ำที่กำหนดเพื่อครอบคลุมผนังของคุณแล้ว',
  OF_KEY: 'ของ',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT: 'ขออภัยไม่รองรับ PDF ที่เข้ารหัส',
  DROPBOX_UPLOAD_PROGRESS_KEY: 'กำลังนำเข้าไฟล์ {0} จาก {1}',
  RECOLORING_KEY: 'กำลังเปลี่ยนสี...',
  TEXT_COLOR_KEY: 'สีข้อความ',
  SOLID_COLOR_KEY: 'สีทึบ',
  MATERIAL_CHOICE_APPLIED: 'เลือกใช้วัสดุ.',
  AUTHENTICATE_DIALOG_TITLE: 'แหล่งเนื้อหานี้มีการป้องกันด้วยรหัสผ่านอยู่',
  AUTHENTICATE_FAILED_MESSAGE: 'การรับรองความถูกต้องล้มเหลว!',
  DROPBOX_IMPORT_ERROR_HEADER: 'เกิดปัญหาขึ้นขณะกำลังนำเข้าไฟล์บางไฟล์',
  HP_FEEDBACK_TEXT: 'HP wants your feedback',
  FEEDBACK_QUERY_TEXT: 'Overall, how satisfied are you with our solutions?',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  FEEDBACK_IMPROVE_TEXT: 'What can we do to improve?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacy Statement',
  INSPIRATION_SIZE_CHANGE_WARNING:
    'เทมเพลต Inspiration นี้มีขนาดเริ่มต้นเป็น {0} X {1} {2} ขนาดหน้าของคุณจะถูกเปลี่ยนโดยอัตโนมัติเพื่อให้พอดีกับเทมเพลตนี้',
  FEEDBACK_PLACEHOLDER_TEXT:
    "We review your feedback to improve our products, so please don't share any personal data or confidential/propreitary content",
  DEFAULT_PROJECT_NAME: 'โปรเจค',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'เลือกแล็ปท็อปของคุณ',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: 'ชื่อจริง',
  LAST_NAME_KEY: 'นามสกุล',
  PHONE_NUMBER_KEY: 'เบอร์โทรศัพท์',
  POSTAL_ADDRESS: 'Postal address',
  COMPANY_NAME: 'Company name',
  INVALID_PHONE_NUMBER_KEY: 'Invalid phone number',
  INVALID_POSTAL_ADDRESS: 'Invalid Postal address',
  INVALID_COMPANY_NAME: 'Invalid Comapany name',
  TERMS_AND_CONDITIONS: 'I accept the terms and conditions.',
  INVOICE_UPLOAD: 'Upload Invoice',
  INVOICE_FILE_MISSING: 'Invoice file missing',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'I accept that my personal information will be shared with HP to be contacted about future HP campaigns. *',
  SERVICE_PROVIDER_CONDITION:
    'I accept that the data I provide may be shared with service providers for the purposes of printing and delivery process.',
  ORDER_DESIGN: 'Order design',
  SUBMIT_YOUR_DESIGN: 'Submit your design',
  SUBMISSION_DESIGN_ORDER: 'Submission for design order',
  ENTER_REQUIRED_FIELDS_KEY: 'กรุณากรอกข้อมูลที่จำเป็น',
  ADDRESS_KEY: 'ที่อยู่',
  INVALID_ADDRESS_KEY: 'ที่อยู่ที่ไม่ถูกต้อง',
  CITY_KEY: 'เมือง',
  INVALID_CITY_KEY: 'เมืองไม่ถูกต้อง',
  COUNTRY_KEY: 'ประเทศ',
  STATE_KEY: 'สถานะ',
  ZIP_KEY: 'ซิป',
  INVALID_ZIP_KEY: 'รหัสไปรษณีย์ไม่ถูกต้อง',
  ORDER_NUMBER: 'หมายเลขสั่งซื้อ',
  YOUR_DETAILS_KEY: 'รายละเอียดของคุณ',
  APPLY_DESIGN_COMPETITION: 'Apply for the design competition',
  NOTICE_KEY: 'หมายเหตุ:',
  CAUTION_FOR_LAPTOP_SELECTION:
    'สำหรับการปรับสภาพผิวพีซีให้เหมาะกับคุณคุณต้องเลือกรุ่นที่ตรงกับการซื้อตามที่ปรากฏในใบแจ้งหนี้',
  RESTART_PROJECT_ALERT_TITLE: 'รีสตาร์ทโครงการหรือไม่',
  DISCARD_ALERT_MESSAGE: 'โครงการปัจจุบันของเราจะถูกยกเลิก',
  RESTART: 'เริ่มต้นใหม่',
  BLOCKCHAIN_STRING: 'Blockchain',
  CERTIFICATE_STRING: 'ใบรับรองของ',
  AUTHENTICITY_STRING: 'ของแท้',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: 'คำเตือนขนาดหน้า!',
  MODIFY_SIZE_WARNING:
    'หากคุณต้องการปรับขนาดการออกแบบนี้คุณสามารถทำได้ในแท็บ "การตั้งค่า" องค์ประกอบการออกแบบอาจต้องมีการแก้ไขเพื่อปรับให้เข้ากับมิติที่คุณต้องการ',
  RANDOMIZE_KEY: 'สุ่ม',
  PLEASE_WAIT: 'โปรดรอ',
  PROTECTING_YOUR_DATA: 'ปกป้องข้อมูลของคุณ...',
  SEARCH_YOUR_LAPTOP_KEY: 'ค้นหาแล็ปท็อปของคุณ', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY: 'อ๊ะ! เราไม่พบแล็ปท็อปสำหรับการค้นหาของคุณ', // Google translated
  SERIAL_NUMBER_KEY: 'หมายเลขซีเรียล',
  LOCKED_PROJECT: 'โปรเจคล็อคอยู่',
  LOCKED_MESSAGE:
    'โปรเจคนี้ได้รับคำสั่งแล้วและไม่สามารถเปลี่ยนแปลงได้ คุณสามารถทำได้เพียงดูโครงการนี้เท่านั้น',
  EXPIRED_PROJECT: 'โปรเจคที่หมดอายุ',
  EXPIRED_MESSAGE: 'โปรเจคนี้หมดอายุแล้ว',
  DELETED_PROJECT: 'โปรเจคที่ถูกลบ',
  DELETED_MESSAGE: 'โปรเจคนี้ถูกลบแล้ว',
  CHOOSE_GROUP_TYPE: 'เลือก {0} ชนิด',
  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: 'โปรดป้อนตัวเลขที่มากกว่าศูนย์',
  SIZE_KEY: 'ขนาด',
  DISTANCE_FROM_KEY: 'ระยะจาก',
  MYROOM_UPPERCASE_KEY: 'ห้องของฉัน',
  FURNITURE_KEY: 'เฟอร์นิเจอร์',
  FIXTURES_KEY: 'เครื่องติดตั้ง',
  ADD_A_WALL_KEY: 'เพิ่มผนัง',
  SELECT_A_WALL_KEY: 'เลือกผนัง',
  LEFT_KEY: 'ซ้าย',
  RIGHT_KEY: 'ขวา',
  DELETE_WALL_KEY: 'ลบผนัง',

  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: 'เลือกประเภทผ้าใบ',
  MAXIMUM_WALL_SIZE_KEY: 'ขนาดของผนังใหญ่ที่สุดคือ {0}sq. {1}.',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY: 'ความสูงของผ้าใบเกินความสูงของผนัง',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY: 'ความกว้างของผ้าใบเกินความกว้างของผนัง',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY:
    'จำนวนคอลัมน์สูงสุดสำหรับความกว้างปัจจุบันคือ {0} คอลัมน์',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY:
    'จำนวนแถวสูงสุดสำหรับความสูงปัจจุบันคือ {0} แถว',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    'ความกว้างผนังน้อยกว่าความกว้างผ้าใบ',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY:
    'ผนังควรมีความกว้างขั้นต่ำอยู่ที่ {0} {1}.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY: 'ผนังควรมีความสูงขั้นต่ำอยู่ที่ {0} {1}.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    'ความสูงผนังน้อยกว่าความสูงผ้าใบ',
  MAXIMUM_WALL_HEIGHT_KEY: 'ความสูงของผนังสูงสุดคือ {0} {1}.',
  FINISHING_KEY: 'ภาพสำเร็จรูป',
  MIRROR_KEY: 'กระจก',
  NATURAL_KEY: 'ธรรมชาติ',
  ROWS_KEY: 'แถว',
  COLUMNS_KEY: 'คอลัมน์',
  DEFAULT_WALL_SIZE_KEY: 'ขนาดผนังเริ่มต้น',
  EDIT_KEY: 'แก้ไข',
  TOP_KEY: 'ด้านบน',
  BOTTOM_KEY: 'ด้านล่าง'
};
